import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import TextWithInputs from 'src/pages/reportUsage/common/textWithInputs/TextWithInputs';
import { getLotSerialInputPlaceHolder } from 'src/pages/reportUsage/utils/dataModificaionUtil';
import Select from 'src/common/refactoredComponents/select/Select';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { StyledDiv } from 'src/pages/consignmentBilling/components/billing/BillingContainer.styled';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const LotSerialRPQtyInput = forwardRef((props, ref) => {
    const {
        item,
        index,
        lotItem,
        addSerialNumber,
        lotSerialValueEntered,
        showTopLabel,
        showBundlefromTableList,
        isFromReportScreen,
        checkNewAddedProduct,
        lotTextAlign,
        vendorCaseErrorRedirection,
        onIsSerialUnknown = () => { },
    } = props;
    const bottomLabelClickHandler = () => {
        if (item.isBundleItem) {
            showBundlefromTableList(true, index, item.productCFN,item?.unqId);
        } else {
            addSerialNumber(item, index);
        }
    };
    useImperativeHandle(ref, () => ({
            bottomLabelClickHandler,
        }));
    const usageDetails = useSelector(
        (state) => state.reportUsageRootReducer.usageDetails
    );
    const { t } = useTranslation();
    const [showClear, setShowClear] = useState(false);
    const [lot, setLot] = useState('');

    useEffectWithErrorLogging(() => {
        setLot(item?.lotSerialNumber ? item?.lotSerialNumber : '');
        setShowClear(item?.lotSerialNumber ? true : false);
    }, [lotItem]);

    return (
        <>
            <SerialRPQtyInputContainer
                height={checkNewAddedProduct && '100%'}
                justifyContent={checkNewAddedProduct && 'flex-start'}
                alignItems={'center'}
            >
                {!checkNewAddedProduct && isFromReportScreen ? (
                    <Box
                        style={{
                            width: '100%',

                            fontSize: '13px',
                            fontFamily: 'AvenirNextWorld Regular',

                            textAlign: lotTextAlign,
                        }}
                    >
                        {item.isBundleItem
                            ? t(
                                  'reportUsage.common.textWithInputs.notApplicable'
                              )
                            : item.lotSerialNumber}
                    </Box>
                ) : (
                    <>
                        {isFromReportScreen && checkNewAddedProduct && (
                            <>
                                {item.batches?.length > 0 ? (
                                    <SelectContainer
                                        display={'flex'}
                                        height={'100%'}
                                        justifyContent={'center'}
                                        alignItems={
                                            checkNewAddedProduct && 'flex-end'
                                        }
                                        maxHeight={
                                            checkNewAddedProduct && '62px'
                                        }
                                    >
                                        <Select
                                            id="reportUsage-lotSerialRPQtyInput-reportPayment-batches"
                                            value={
                                                item?.lotSerialUnknown
                                                    ? ''
                                                    : lot
                                            }
                                            options={item.batches}
                                            name={'batches'}
                                            onChange={(e) => {
                                                lotSerialValueEntered(
                                                    e,
                                                    item,
                                                    index
                                                );
                                                setLot(e.batches);
                                                setShowClear(
                                                    e.batches?.length > 0
                                                );
                                            }}
                                            placeholder={getLotSerialInputPlaceHolder(
                                                item,
                                                t('reportUsage.unknown')
                                            )}
                                            borderRadius={'6px'}
                                            border={'1.5px solid #EBEDED'}
                                            width={'70%'}
                                            editable={true}
                                            showClear={showClear}
                                            crossIconMargin={'-5px'}
                                            showOnFocus={true}
                                        />
                                    </SelectContainer>
                                ) : (
                                    <TextWithInputs
                                        id={`reportUsage-lot-serial-input-${item.productCFN}-${index}`}
                                        styleObj={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems:
                                                checkNewAddedProduct &&
                                                'flex-end',
                                            maxHeight: item.noItemInBundleErr
                                                ? '87px'
                                                : checkNewAddedProduct &&
                                                  '62px',
                                        }}
                                        width={
                                            item.isBundleItem
                                                ? item.noItemInBundleErr
                                                    ? '75%'
                                                    : '100%'
                                                : '70%'
                                        }
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={12}
                                        name={'lotSerialNumber'}
                                        bottomLabel={
                                            !item.isInvalidItemMsg &&
                                            item.isBundleItem &&
                                            t(
                                                'reportUsage.record.reportPayment.ItemList.ReportPaymentItemListMobile.addItems'
                                            )
                                        }
                                        topLabel={
                                            showTopLabel
                                                ? item?.cfn?.startsWith('S33')
                                                    ? t(
                                                          'reportUsage.record.itemsList.LotSerialQtyInput.addItems'
                                                      )
                                                    : t(
                                                          'reportUsage.record.itemsList.LotSerialQtyInput.lotSerial'
                                                      )
                                                : ''
                                        }
                                        placeholder={getLotSerialInputPlaceHolder(
                                            item,
                                            t('reportUsage.unknown')
                                        )}
                                        inputDisabled={
                                            item.isBundleItem ||
                                            (item?.cfn?.startsWith('S33') &&
                                                usageDetails?.vendorCaseId?.startsWith(
                                                    'UH_'
                                                )) ||
                                            (item?.cfn?.startsWith('S33') &&
                                                usageDetails?.vendorCaseId?.startsWith(
                                                    'AH_'
                                                ))
                                        }
                                        onLabelClick={bottomLabelClickHandler}
                                        onkeyUp={(e) =>
                                            lotSerialValueEntered(
                                                e,
                                                item,
                                                index
                                            )
                                        }
                                        isBundleItem={item.isBundleItem}
                                        cursor={'pointer'}
                                        inputBorder={
                                            item.isInvalidLotSerialMsg?.length >
                                                0 && '2px solid #FACFD6'
                                        }
                                        lotSerial={true}
                                        defaultValue={
                                            item?.lotSerialUnknown
                                                ? ''
                                                : item?.lotSerialNumber
                                        }
                                        value={
                                            item?.lotSerialUnknown
                                                ? ''
                                                : item?.lotSerialNumber
                                        }
                                        vendorCaseErrorRedirection={
                                            vendorCaseErrorRedirection
                                        }
                                        noItemInBundleErr={
                                            item.noItemInBundleErr
                                        }
                                    />
                                )}
                            </>
                        )}
                    </>
                )}
            </SerialRPQtyInputContainer>
        </>
    );
});

export default LotSerialRPQtyInput;

export const SerialRPQtyInputContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 8px;
    justify-content: ${({ justifyContent }) => justifyContent};
    height: ${({ height }) => height};
    align-items: ${({ alignItems }) => alignItems};
`;

export const ErrorContainer = styled.div`
    width: 70%;
`;
export const SelectContainer = styled.div`
    display: ${({ display }) => display};
    align-items: ${({ alignItems }) => alignItems};
    max-height: ${({ maxHeight }) => maxHeight};
    justify-content: ${({ justifyContent }) => justifyContent};
    height: ${({ height }) => height};
`;
